import * as React from "react";
import { forwardRef } from "react";
const SvgRelationBoth = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 29 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.5 7.00003H5V5.00001H10.5V7.00003Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24 7H18.5V4.99998H24V7Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M14.5 10.5C16.9852 10.5 19 8.48529 19 6C19 3.51472 16.9852 1.5 14.5 1.5C12.0148 1.5 10 3.51472 10 6C10 8.48529 12.0148 10.5 14.5 10.5ZM14.5 9C16.1569 9 17.5 7.65686 17.5 6C17.5 4.34315 16.1569 3 14.5 3C12.8431 3 11.5 4.34315 11.5 6C11.5 7.65686 12.8431 9 14.5 9Z",
	fill: "currentColor",
	fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24 12L22.5 10.5L26.5 6L22.5 1.5L24 0L29 5.99995L24 12Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 12L6.5 10.5L2.5 6L6.5 1.5L5 0L0 5.99995L5 12Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 6C16 6.82843 15.3284 7.5 14.5 7.5C13.6716 7.5 13 6.82843 13 6C13 5.17157 13.6716 4.5 14.5 4.5C15.3284 4.5 16 5.17157 16 6Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgRelationBoth);
export default ForwardRef;
